import ApiUtil from './apiutil';

import domains from './domains';

const { api, https } = ApiUtil;

const domainMap = new Map();

Object.keys(domains).forEach(v => domainMap.set(v, domains[v][process.env.VUE_APP_APIDOMAIN]));

const files = require.context('./modules', false, /\.js/);

let apis = {};

files.keys().forEach(key => {
    const moduleName = key.slice(2, -3);
    apis[moduleName] = {};

    files(key).default.forEach(v => {
        // komoe东南亚除帐号相关接口外url需传通用参数 region = 8，账号相关接口传 region = 7
        if (process.env.VUE_APP_APIDOMAIN === 'sea') {
            if (v.mode !== 'passport' && v.mode !== 'pay') {
                v.options.region8 = true;
            }
        }
        // 切线相关接口的前缀
        // 原passport相关的接口无切线，现日本平台的passport接口有切线且前缀为line1、line2、line3
        let urlPrefix = '//l1';
        if(v.mode === 'passport'){
            v.switch = true;
            if (v.type === 'POST') {
                // 是否在post请求的url上拼接lang
                v.options.postUrlLang = true;
            }
        }
        let web_code = ''
        // 小萌台湾
        if (process.env.VUE_APP_THEME === 'komoe' && process.env.VUE_APP_AREA === 'komoe') {
            web_code = 'o_komoe_tw_c691c2a4589da6c'
        }
        // 小萌东南亚
        if (process.env.VUE_APP_THEME === 'komoe' && process.env.VUE_APP_AREA === 'komoe-sea') {
            web_code = 'g_komoe_s_e_a_7436e5cb0cb49ff'
        }
        // bi 日本
        if (process.env.VUE_APP_THEME === 'bi' && process.env.VUE_APP_AREA === 'jp') {
            web_code = 'g_bili_jp_d2ff667ff69f117'
        }
        if (v.mode === 'cs') {
            v.options.web_code = web_code
        }
        let path = v.switch ? [1, 2, 3].map(w => {
            v.path = v.path.replace(/^\/komoe/, '');
            let domain;
            if (process.env.VUE_APP_APIDOMAIN === 'komoe' && v.mode === 'passport' && v.params && v.params.indexOf('changeBaseUrl') > -1) {
              domain = domainMap.get(v.mode);
              domain = domain.replace(/\/komoejoy/, '/komoe');
            } else {
              domain = domainMap.get(v.mode)
            }
            return https(`${urlPrefix}${w}-${ domain + v.path}`);
        }) : https(domainMap.get(v.mode) + v.path);
        apis[moduleName][v.method] = api(v.type, path, v.params, v.options, v.mode);
    });
});

export default apis;